export const cutsetName = 'cutset';
export const exactConstraintIdName = 'exactConstraintId';
